const utmParamKeys = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'gclid'
];

const storageKey = 'utm_params';
const expiryTimeMs = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

export const utmHelper = {
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const utmData = {};

    utmParamKeys.forEach((paramKey) => {
      const urlParamValue = urlParams.get(paramKey);
      if (urlParamValue) {
        utmData[paramKey] = urlParamValue;
      }
    });

    // Only save if we found at least one UTM param
    if (Object.keys(utmData).length > 0) {
      const dataWithTimestamp = {
        ...utmData,
        timestamp: Date.now()
      };
      sessionStorage.setItem(storageKey, JSON.stringify(dataWithTimestamp));
    } else {
      // Check if existing data has expired
      const storedParams = sessionStorage.getItem(storageKey);
      if (storedParams) {
        try {
          const parsedParams = JSON.parse(storedParams);
          if (parsedParams.timestamp && Date.now() - parsedParams.timestamp > expiryTimeMs) {
            sessionStorage.removeItem(storageKey);
          }
        } catch {
          sessionStorage.removeItem(storageKey);
        }
      }
    }
  }
};
